"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestParameters2PageRequest = exports.pageRequest2RequestQueryStringParameters = void 0;
function pageRequest2RequestQueryStringParameters(pr) {
    if (pr)
        return `page=${pr.pageNumber}&size=${pr.pageSize}`;
    else
        return "";
}
exports.pageRequest2RequestQueryStringParameters = pageRequest2RequestQueryStringParameters;
function requestParameters2PageRequest(parameters) {
    if (parameters.page && parameters.size) {
        return {
            pageNumber: parseInt(parameters.page),
            pageSize: parseInt(parameters.size)
        };
    }
    else {
        return undefined;
    }
}
exports.requestParameters2PageRequest = requestParameters2PageRequest;
